import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import { cn } from '@/lib/utils';

interface EllipsisCellProps {
  text: string | null | undefined;
  /** 잘림 기준 폭(기본 44ch). */
  className?: string;
}

/** 한 줄 말줄임 셀 + 전체 텍스트 툴팁 — 워크스페이스 `EllipsisCell` 이식(긴 공고 제목 등 표 셀 공용). */
export function EllipsisCell({ text, className }: EllipsisCellProps) {
  if (!text) return <span className="text-muted-foreground">—</span>;
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span className={cn('block max-w-[44ch] truncate', className)}>{text}</span>
      </TooltipTrigger>
      <TooltipContent side="top" align="start" className="max-w-[60ch]">
        {text}
      </TooltipContent>
    </Tooltip>
  );
}
